import * as React from 'react';
import { render } from 'react-dom';
import * as superagent from 'superagent';

import { ISimilarObjectsSopr } from './components/similar_objects_sopr';

interface ISimilarObjectsSoprSuccess {
  body: {
    status: string;
    data: {
      similarOffers: ISimilarObjectsSopr[];
    }
  }
}

interface ISimilarObjectsSoprError {
  error: {
    status: number;
    message: string;
  };
}

function getSimilarObjectSopr(cianOfferId: number): Promise<ISimilarObjectsSopr[]> {
  return new Promise((resolve, reject) => {
    superagent
      .get('/cian-api/site/v1/get-similar-offers-by-offer-id/')
      .query({ cianOfferId })
      .send()
      .end((error: ISimilarObjectsSoprError, response: ISimilarObjectsSoprSuccess) => {
        if (error) {
          reject(error);
        }

        if (response.body.data && response.body.data.similarOffers) {
          resolve(response.body.data.similarOffers);
        } else {
          reject(new Error('Get similar object from sorp completed with error'));
        }
      });
  });
}

export default function initSimilarObjectsSopr() {
  (window as any).renderSimilarObjectsSopr = (container: HTMLElement, cianID: number) => {
    getSimilarObjectSopr(cianID)
      .then(similarOffers => {
        if (similarOffers.length) {
          require.ensure(['./components/similar_objects_sopr.tsx'], () => {
            const SimilarObjectsSopr = require('./components/similar_objects_sopr').default;

            render(
              <SimilarObjectsSopr similarOffers={similarOffers} cianOfferId={cianID} />,
              container,
            );
          });
        }
      })
      .catch(error => {
        console.error(error)
      });
  };
}



// WEBPACK FOOTER //
// ./src/bundles/similar_objects_sopr/index.tsx